import React from 'react';
import { ActivityPost } from '@components/feed/Feed/components/ActivityPost';
import { INewsItemPublishedActivity } from './interfaces';
import { Trans, useTranslation } from 'react-i18next';
import { Box, CardMedia, Link, Typography } from '@mui/material';
import { ROUTES } from '@routes/routes';
import { useNavigate } from 'react-router';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import ChatIcon from '@mui/icons-material/Chat';
import { Image } from '@components/Image';
import { ActivityOverlayChip } from '../../components/ActivityOverlayChip';

export const NewsItemPublishedActivity: React.FC<
  INewsItemPublishedActivity
> = ({
  title,
  excerpt,
  date,
  slug,
  coverImageId,
  totalComments,
}): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const activityTitle = (
    <Trans
      i18nKey={'activities:newsItemPublished.title'}
      values={{
        title,
      }}
      components={{
        bold: <strong />,
      }}
    />
  );

  return (
    <ActivityPost
      title={activityTitle}
      date={date}
      icon={NewspaperIcon}
      onClick={() => navigate(ROUTES.portal.news.details(slug))}
    >
      {coverImageId && (
        <CardMedia
          component="div"
          sx={{
            position: 'relative',
            mb: 1,
          }}
        >
          <Image
            imageSrc={ROUTES.images.image(coverImageId)}
            aspectRatio={700 / 300}
          />
          {totalComments !== undefined && totalComments !== null && (
            <Box
              sx={{
                position: 'absolute',
                right: '8px',
                bottom: '10px',
              }}
            >
              <ActivityOverlayChip
                icon={<ChatIcon />}
                label={`${totalComments} ${t('feed:buttons.reactions', {
                  count: totalComments,
                }).toLocaleLowerCase()}`}
              />
            </Box>
          )}
        </CardMedia>
      )}

      <Typography variant="body2">
        {excerpt}
        <Link
          fontSize=".9rem"
          sx={{
            ml: '.3em',
          }}
        >
          {t('buttons.readMore')}
        </Link>
      </Typography>
    </ActivityPost>
  );
};
